import { render } from "./PaySuccess.vue?vue&type=template&id=bf599238"
import script from "./PaySuccess.vue?vue&type=script&lang=js"
export * from "./PaySuccess.vue?vue&type=script&lang=js"

import exportComponent from "/home/jpom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__